module.exports = __webpack_public_path__ + "media/signup-react/share-feedback-92a40f71.png";